
import {gsap} from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText, ScrollTrigger);

const init = () => {
    
    const introTitle = document.querySelector('.wordsAnimation');
    
    if(!introTitle){
        return;
    }

    let tl = gsap.timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
            trigger: ".wordsAnimation",
            once: true,
            pin: false, 
            start: "top 90%",
            scrub: false,
        }
    }),
    mySplitText = new SplitText('.wordsAnimation p', { type: "words" }),
    words = mySplitText.words;

    // add animations and labels to the timeline
    tl
    .fromTo(words, 
        {autoAlpha: 0, y: 20}, 
        {duration: 0.8, ease: "expo.out", autoAlpha: 1, y: 0, stagger: 0.03});

}

export default {init};